import { commonCrudOption } from '@/const/crud/commonOption'
import { getToken } from '@/utils/auth'

const isNumberValidator = (rule, value, callback) => {
  if (value && isNaN(value)) {
    callback(new Error('请输入数字'))
  } else {
    callback()
  }
}

export const getTableOption = (self) => ({
  ...commonCrudOption,
  dialogCustomClass: 'carportEditDialog',
  // dialogWidth: '40%',
  // menuWidth: 200,
  labelWidth: 140,
  searchSpan: 5,
  // searchIndex: 3,
  searchMenuSpan: 4,
  tabs: true,
  column: [
    {
      label: '车位区域',
      prop: 'location',
      minWidth: 200,
      display: false
    },
    {
      label: '车位名称',
      prop: 'name',
      searchOrder: 9,
      search: true,
      minWidth: 150,
      display: false
    },
    {
      label: '产权性质',
      prop: 'propertyOwnerType',
      searchOrder: 5,
      dicUrl: process.env.VUE_APP_BASE_API + '/api/dict/CW-CWCQXZ',
      dicHeaders: {
        Authorization: getToken()
      },
      props: {
        children: 'children',
        label: 'name',
        value: 'code'
      },
      searchMenuSpan: 18,
      type: 'select',
      search: true,
      minWidth: 100,
      display: false,
      rules: [{
        required: true,
        message: '请选择',
        trigger: 'change'
      }],
      control: (val, form) => {
        if (!val) {
          return
        }
        if (val === 'CW-CWCQXZ-KHCQ') {
          return {
            conductCode: {
              display: true
            },
            conductValidateDate: {
              display: true
            },
            customerName: {
              display: true,
              label: '产权人'
            },
            chargeStartDate: {
              display: true
            },
            chargeEndDate: {
              display: true
            },
            houseCode: {
              display: true
            },
            houseCustomerList: {
              display: true
            },
            takeoverDate: {
              display: true
            },
            wyActualTakeoverDate: {
              display: true
            }
            // propertyImgs: {
            //   display: false
            // }
          }
        } else if (val === 'CW-CWCQXZ-WYCQ') {
          return {
            customerName: {
              display: true,
              label: '物业公司名称'
            },
            conductCode: {
              display: false
            },
            conductValidateDate: {
              display: false
            },
            chargeStartDate: {
              display: false
            },
            chargeEndDate: {
              display: false
            },
            houseCode: {
              display: false
            },
            takeoverDate: {
              display: true
            },
            // propertyImgs: {
            //   display: false
            // },
            houseCustomerList: {
              display: false
            },
            wyActualTakeoverDate: {
              display: true
            }
          }
        } else if (val === 'CW-CWCQXZ-QTCQ') {
          return {
            customerName: {
              display: false
            },
            takeoverDate: {
              display: true
            },
            wyActualTakeoverDate: {
              display: true
            },
            conductCode: {
              display: false
            },
            conductValidateDate: {
              display: false
            },
            chargeStartDate: {
              display: false
            },
            chargeEndDate: {
              display: false
            },
            houseCode: {
              display: false
            },
            // propertyImgs: {
            //   display: false
            // }
            houseCustomerList: {
              display: false
            }
          }
        }
      }
    },
    {
      searchOrder: 10,
      label: '产权人',
      prop: 'customerName',
      search: true,
      display: false,
      clearable: true,
      suffixIcon: 'el-icon-search',
      readonly: true,
      focus: ({ value, column }) => {
        self?.openSelectCustomer()
      }
    },
    {
      label: '车位类型',
      prop: 'type',
      display: false,
      searchOrder: 4,
      dicUrl: process.env.VUE_APP_BASE_API + '/api/dict/CW-CWLX',
      dicHeaders: {
        Authorization: getToken()
      },
      props: {
        children: 'children',
        label: 'name',
        value: 'code'
      },
      type: 'select',
      search: true,
      minWidth: 100
    },
    {
      label: '车位状态',
      prop: 'usageStatus',
      dicUrl: process.env.VUE_APP_BASE_API + '/api/dict/CW-CWZT',
      dicHeaders: {
        Authorization: getToken()
      },
      props: {
        children: 'children',
        label: 'name',
        value: 'code'
      },
      type: 'select',
      minWidth: 100,
      display: false
    },
    {
      label: '建筑面积',
      prop: 'areaCharge',
      width: 120,
      showColumn: false,
      display: false,
      hide: true
    },
    {
      label: '绑定收费标准',
      prop: 'conductName',
      minWidth: 200,
      display: false
    },
    {
      label: '计费开始日期',
      prop: 'chargeStartDate',
      minWidth: 200,
      display: false,
      rules: [{
        required: true,
        message: '请选择计费开始日期',
        trigger: 'change'
      }]
    },
    {
      label: '计费结束日期',
      prop: 'chargeEndDate',
      minWidth: 200,
      display: false,
      rules: [{
        required: true,
        message: '请选择计费结束日期',
        trigger: 'change'
      }]
    },
    {
      label: '合同接收日期',
      prop: 'takeoverDate',
      display: false,
      minWidth: 200
    },
    {
      label: '实际接收日期',
      prop: 'wyActualTakeoverDate',
      display: false,
      minWidth: 200
    },
    {
      label: '备注',
      prop: 'memo',
      minWidth: 100,
      display: false
    }
  ],
  group: [
    {
      label: '基本信息',
      icon: 'el-icon-edit-outline',
      column: [
        {
          label: '车位名称',
          prop: 'name',
          rules: [{
            required: true,
            message: '请输入',
            trigger: 'change'
          }]
        },
        {
          label: '车位区域',
          prop: 'pId',
          formslot: true,
          viewDisplay: false,
          rules: [{
            required: true,
            message: '请选择车位区域',
            trigger: 'change'
          }]
        },
        {
          label: '车位区域',
          prop: 'location',
          editDisplay: false,
          addDisplay: false,
          viewDisplay: true
        },
        {
          label: '车位类型',
          prop: 'type',
          dicUrl: process.env.VUE_APP_BASE_API + '/api/dict/CW-CWLX',
          dicHeaders: {
            Authorization: getToken()
          },
          props: {
            children: 'children',
            label: 'name',
            value: 'code'
          },
          type: 'select',
          rules: [{
            required: true,
            message: '请选择',
            trigger: 'change'
          }],
          minWidth: 100
        },
        {
          label: '建筑面积',
          prop: 'areaCharge',
          append: '㎡',
          rules: [
            {
              validator: isNumberValidator,
              trigger: 'change'
            }
          ]
        }
      ]
    },
    {
      label: '产权信息',
      icon: 'el-icon-edit-outline',
      column: [
        {
          label: '产权性质',
          prop: 'propertyOwnerType',
          dicUrl: process.env.VUE_APP_BASE_API + '/api/dict/CW-CWCQXZ',
          dicHeaders: {
            Authorization: getToken()
          },
          editDisabled: true,
          props: {
            children: 'children',
            label: 'name',
            value: 'code'
          },
          type: 'select',
          minWidth: 100,
          rules: [{
            required: true,
            message: '请选择',
            trigger: 'change'
          }]
        },
        {
          label: '产权人',
          prop: 'customerName',
          display: false,
          formslot: true,
          rules: [{
            required: true,
            message: '请选择产权人',
            trigger: 'change'
          }]
        },
        {
          label: '产权关联房屋',
          prop: 'houseCustomerList',
          display: false,
          formslot: true
        },
        {
          label: '费用标准',
          prop: 'conductCode',
          viewDisplay: false,
          formslot: true,
          display: false,
          rules: [{
            required: true,
            message: '请选择费用标准',
            trigger: 'change'
          }]
        },
        {
          label: '费用标准启用时间',
          viewDisplay: false,
          prop: 'conductValidateDate',
          display: false,
          formslot: true
        },
        {
          label: '计费开始日期',
          display: false,
          prop: 'chargeStartDate',
          type: 'date',
          viewDisplay: false,
          valueFormat: 'yyyy-MM-dd',
          minWidth: 200,
          rules: [{
            required: true,
            message: '请选择计费开始日期',
            trigger: 'change'
          }]
        },
        {
          label: '计费结束日期',
          display: false,
          prop: 'chargeEndDate',
          viewDisplay: false,
          type: 'date',
          minWidth: 200,
          valueFormat: 'yyyy-MM-dd',
          rules: [{
            required: true,
            message: '请选择计费结束日期',
            trigger: 'change'
          }]
        },
        // {
        //   label: '产权关联房屋',
        //   prop: 'houseCode',
        //   display: false,
        //   formslot: true
        // },
        // {
        //   label: '上传车位产权证',
        //   prop: 'propertyImgs',
        //   display: false,
        //   type: 'upload',
        //   listType: 'picture-card',
        //   action: process.env.VUE_APP_BASE_API + '/api/localStorage/pictures',
        //   propsHttp: {
        //     name: 'name',
        //     url: 'path'
        //   },
        //   withCredentials: true,
        //   headers: {
        //     Authorization: getToken()
        //   }
        // },
        {
          label: '合同接收日期',
          prop: 'takeoverDate',
          display: false,
          type: 'date',
          valueFormat: 'yyyy-MM-dd',
          minWidth: 200
        },
        {
          label: '实际接手日期',
          prop: 'wyActualTakeoverDate',
          type: 'date',
          display: false,
          valueFormat: 'yyyy-MM-dd',
          minWidth: 200
        }
      ]
    },
    {
      label: '产权转移记录',
      icon: 'el-icon-set-up',
      addDisplay: false,
      editDisplay: false,
      viewDisplay: true,
      column: [
        {
          label: '',
          labelWidth: '0px',
          prop: 'transferList',
          formslot: true
        }
      ]
    }
    // {
    //   label: '费用标准',
    //   icon: 'el-icon-money',
    //   addDisplay: false,
    //   editDisplay: false,
    //   viewDisplay: true,
    //   column: [
    //     {
    //       label: '',
    //       labelWidth: '0px',
    //       prop: 'feeStandradList',
    //       formslot: true
    //     }
    //   ]
    // }
  ]
})

export const getUnpayOption = () => ({
  border: true,
  addBtn: false,
  editBtn: false,
  delBtn: false,
  index: false,
  searchBtn: false,
  maxHeight: 400,
  refreshBtn: false,
  menu: false,
  columnBtn: false,
  column: [
    {
      minWidth: 150,
      label: '车位名称',
      prop: 'parkspotName'
    },
    {
      minWidth: 150,
      label: '房屋名称',
      prop: 'houseName'
    },
    {
      minWidth: 120,
      label: '客户名称',
      prop: 'customerName'
    },
    {
      minWidth: 150,
      label: '费用日期',
      prop: 'feesDate'
    },
    {
      minWidth: 150,
      label: '费用开始日期',
      prop: 'feesStartDate'
    },
    {
      minWidth: 150,
      label: '费用结束时间',
      prop: 'feesEndDate'
    },
    {
      minWidth: 150,
      label: '收费科目名称',
      prop: 'accountName'
    },
    {
      minWidth: 150,
      label: '总金额',
      prop: 'amountTotal'
    },
    {
      minWidth: 150,
      label: '累计减免金额',
      prop: 'amountReduce'
    },
    {
      minWidth: 150,
      label: '欠费金额',
      prop: 'amountTopay'
    },
    {
      minWidth: 150,
      label: '违约金金额',
      prop: 'amountLatefeePaid'
    },
    {
      minWidth: 150,
      label: '违约金减免金额',
      prop: 'amountLatefeeReduce'
    },
    {
      minWidth: 150,
      label: '违约金待支付金额',
      prop: 'amountLatefeeTopay'
    },
    {
      minWidth: 150,
      label: '账单缴费金额',
      prop: 'amountPaid'
    }
  ]
})

export const getTransferTableOption = () => ({
  border: true,
  addBtn: false,
  editBtn: false,
  delBtn: false,
  index: false,
  searchBtn: false,
  refreshBtn: false,
  menu: false,
  columnBtn: false,
  column: [
    {
      minWidth: 150,
      label: '新产权人姓名',
      prop: 'customerNameNew'
    },
    // {
    //   minWidth: 150,
    //   label: '车位产权证',
    //   prop: 'propertyImg1'
    // },
    {
      minWidth: 150,
      label: '老产权人姓名',
      prop: 'customerNames'
    },
    {
      minWidth: 150,
      label: '老产权人联系电话',
      prop: 'customerPhones'
    },
    {
      minWidth: 180,
      label: '老产权人接手车位时间',
      prop: 'propertyTime'
    },
    {
      minWidth: 180,
      label: '老产权人转出车位时间',
      prop: 'transferDate'
    }
  ]
})
